import {
  UseFormRegister,
  FieldErrorsImpl,
  DeepRequired,
} from "react-hook-form";
import { HookFormCheckbox } from "../../../hook-form";
import { IOnboardingStep4Request } from "../../../interfaces-and-types";

export const OnboardingCheckboxWithTitle = ({
  name,
  title,
  label,
  disabled,

  register,
  errors,
}: {
  name: keyof IOnboardingStep4Request;
  title: string;
  label?: string;
  disabled: boolean;

  register: UseFormRegister<IOnboardingStep4Request>;
  errors: FieldErrorsImpl<DeepRequired<IOnboardingStep4Request>>;
}) => {
  return (
    <div className="flex-container align-items--center titled-checkbox--container">
      <div className="checkbox-wrapper">
        <HookFormCheckbox
          name={name}
          label={""}
          register={register}
          errors={errors}
          className=""
          disabled={disabled}
        />
      </div>
      <div className="flex-box col align-items--center title-container">
        <label htmlFor={name}>
          <div className="checkbox-title font-ctm--bold">{title}</div>
          {!label ? null : (
            <div className="checkbox-description switchapp-small">{label}</div>
          )}
        </label>
      </div>
    </div>
  );
};
